export const rowNewApplication = (purposeOfEnq, gender, marriageStatus, educationalStatusCode, nameAsId, fullName, motherName, birthDate, birthPlace, address, subDistrict, district, city, postalCode, country, identityType, identityNumber, npwp, phoneNumber, cellphoneNumber, emailAddress, resident, occupation, workplace, employerSelector, workplaceAddress, roleInApplication, dueDate, applicationAmount, contractType, currency, originalAgreementNumber, originalAgreementDate) => {

    const subject = `
    <cb:Subject SubjectRefDate="2019-11-22">
    <cb:Individual DebtorGroupCodeInd="${resident ?? ''}" Gender="${gender ?? ''}" MarriageStatus="${marriageStatus ?? ''}" EducationalStatusCode="${educationalStatusCode ?? ''}">
    <cb:IndividualName NameAsId="${nameAsId ?? ''}" FullName="${fullName ?? ''}" MothersName="${motherName ?? ''}" />
    <cb:BirthData BirthDate="${birthDate ?? ''}" BirthPlace="${birthPlace ?? ''}" />
    <cb:Address Address="${address ?? ''}" SubDistrict="${subDistrict ?? ''}" District="${district ?? ''}" City="${city ?? ''}" PostalCode="${postalCode ?? ''}" Country="${country ?? ''}"/>
    <cb:IdentificationCode IdentityType="${identityType ?? ''}" IdentityNumber="${identityNumber ?? ''}" />
    <cb:ID NPWP="${npwp ?? ''}" />
    <cb:Contact PhoneNumber="${phoneNumber ?? ''}" CellphoneNumber="${cellphoneNumber ?? ''}" EmailAddress="${emailAddress ?? ''}" />
    <cb:EmploymentData JobCode="${occupation ?? ''}" Workplace="${workplace ?? ''}" CodeOfBusiness="${employerSelector ?? ''}" WorkplaceAddress="${workplaceAddress ?? ''}" /> 
    </cb:Individual>
    </cb:Subject>`;

    const application = `
    <cb:Application ContractCategoryCode="F01" ContractTypeCode="${contractType}" ContractPhase="RQ" ContractRequestDate="2020-10-10" Currency="${currency ?? ''}">
    <cb:Credit ApplicationAmount="${applicationAmount ?? ''}" DueDate="${dueDate ?? ''}" OriginalAgreementNumber="${originalAgreementNumber ?? ''}" OriginalAgreementDate="${originalAgreementDate ?? ''}" />
    </cb:Application>`;

    const link = `
    <cb:Link Role="${roleInApplication ?? ''}" />`;

    const applicationCode = `
    <cb:ApplicationCodes ProviderContractNo="" ProviderApplicationNo="${Date.now()}" CBContractCode=""/>`;

    const purPoseCode = `
    <cb:Purpose PurposeCode="${purposeOfEnq ?? ''}" />`;

    // const username = 'MOLA6665';
    // const password = '99TauD(@2T';

    const username = 'QIPO0201';
    const password = 'x/S15__239';

    const bodyRow = `
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:urn="urn:cbs-messagegatewaysoap:2015-01-01">
    <soapenv:Header/>
    <soapenv:Body xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema">
        <urn:MGRequest xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
        <urn:Message GroupId="2b668cb9-038e-413d-b9c2-dfbc38c4104f" Id="45397ed8-dbd7-4b61-aa0d-b497e88a9548" TimeStamp="2017-04-11T14:42:47.662197+01:00" Idempotence="unique" xmlns="urn:cbs-messagegatewaysoap:2015-01-01">
            <urn:Credential Domain="" Id="${username}" Password="${password}"/>
        </urn:Message>
        <urn:Product ServiceId="CBG" Id="CB_NAE_Product" Version="" xmlns="urn:cbs-messagegatewaysoap:2015-01-01">
            <cb:CB_NAE_ProductInput xmlns:cb="urn:crif-creditbureau:v1">
            ${subject}
            ${application}
            ${link}
            ${applicationCode}
            ${purPoseCode}
            </cb:CB_NAE_ProductInput>
        </urn:Product>
        </urn:MGRequest>
    </soapenv:Body>
    </soapenv:Envelope>`;

    return bodyRow;
};

export const rowMonitoringBySubject = () => {
    const subject = `
    <cb:Subject>
    <cb:Individual Gender="M" Resident="" MarriageStatus="" EducationalStatus="">
    <cb:IndividualName MothersName="SUSI SIMILIKITI" NameAsId="FAHRUDIN SUDUNG" FullName="FAHRUDIN SUDUNG"/>
    <cb:BirthData BirthDate=“YYYY-MM-DD" BirthPlace="SOLO"/>
    <cb:Address Address="KOMPLEK PRABU MERAH NO 2A BARAT, JL AGUNG, CIATER, Pamulang, Kota Tangerang Selatan, 11111, INDONESIA
    " SubDistrict="Pamulang" District="Kota Tangerang Selatan" City="0110" PostalCode="11111" Country="ID"/>
    <cb:IdentificationCode IdentityType="1" IdentityNumber="1207232505740999"/>
    <cb:ID NPWP=""/>
    <cb:Contact PhoneNumber="" CellphoneNumber="0813622588464" EmailAddress="UDIN@YMAIL.COM"/>
    <cb:EmploymentData OccupationCode="" Workplace="" EmployerSector="" WorkplaceAddress=""/>
    </cb:Individual>
    </cb:Subject>
    `;

    const purposeCode = `
    <cb:Purpose PurposeCode="10"/>
    `;

    const bodyRow = `
    <soapenv:Envelope xmlns:urn="urn:cbs-messagegatewaysoap:2015-01-01" xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
    <soapenv:Header/>
    <soapenv:Body xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
    <urn:MGRequest>
    <urn:Message Idempotence="unique" TimeStamp="2018-11-26T14:42:47.662197+01:00" Id="767676" GroupId="55657" xmlns="urn:cbs-
    messagegatewaysoap:2015-01-01">
    <urn:Credential Id=“USERNAME" Password=“PASSWORD" Domain=""/>
    </urn:Message>
    <urn:Product Id="CB_ME_Product" Version="" ServiceId="CB" xmlns="urn:cbs-messagegatewaysoap:2015-01-01">
    <cb:CB_ME_ProductInput xmlns:cb="urn:crif-creditbureau:v1">
    ${subject}
    ${purposeCode}
    </cb:CB_ME_ProductInput>
    </urn:Product>
    </urn:MGRequest>
    </soapenv:Body>
    </soapenv:Envelope>
    `;

    return bodyRow;
};

export const rowMonitoringBySubjectCode = () => {
    const subjectCode = `
    <cb:SubjectCodes CBSubjectCode="I00014752"/>
    `;

    const purposeCode = `
    <cb:Purpose PurposeCode="10"/>
    `;

    const bodyRow = `
    <soapenv:Envelope xmlns:urn="urn:cbs-messagegatewaysoap:2015-01-01" xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
    <soapenv:Header/>
    <soapenv:Body xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
    <urn:MGRequest>
    <urn:Message Idempotence="unique" TimeStamp="2018-11-26T14:42:47.662197+01:00" Id="767676" GroupId="55657" xmlns="urn:cbs-
    messagegatewaysoap:2015-01-01">
    <urn:Credential Id=“USERNAME" Password=“PASSWORD" Domain=""/>
    </urn:Message>
    <urn:Product Id="CB_ME_Product" Version="" ServiceId="CB" xmlns="urn:cbs-messagegatewaysoap:2015-01-01">
    <cb:CB_ME_ProductInput xmlns:cb="urn:crif-creditbureau:v1">
    ${subjectCode}
    ${purposeCode}
    </cb:CB_ME_ProductInput>
    </urn:Product>
    </urn:MGRequest>
    </soapenv:Body>
    </soapenv:Envelope>
    `;

    return bodyRow;
};

export const rowPortfolioEnq = () => {
    const prodService = `
    <urn:Product ServiceId="CB" Id="CB_PAE_Product" Version="" xmlns="urn:cbs-messagegatewaysoap:2015-01-01">
    <cb:CB_PAE_ProductInput xmlns:cb="urn:crif-creditbureau:v1">
    <cb:ExtractionParameters DateFrom="" DateTo="" SubjectName="" CBSubjectCode=""
    CBContractCode="" AlertCode="" DownloadLevel="Provider" ProviderTypeCode="" ProviderCode="" BranchCode="" UserCode="" DownloadType="ALL"
    OnlyCardinalityFlag="0"/>
    </cb:CB_PAE_ProductInput>
    </urn:Product>
    `;

    const rowBody = `
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:urn="urn:cbs-messagegatewaysoap:2015-01-01">
    <soapenv:Header/>
    <soapenv:Body xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema">
    <urn:MGRequest xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
    <urn:Message GroupId="2b668cb9-038e-413d-b9c2-dfbc38c4104f" Id="45397ed8-dbd7-4b61-aa0d-b497e88a9548"
    TimeStamp="2017-04-11T14:42:47.662197+01:00" Idempotence="unique" xmlns="urn:cbs-messagegatewaysoap:2015-01-01">
    <urn:Credential Domain="" Id=“USERID" Password=“PASSWORD"/>
    </urn:Message>
    ${prodService}
    </urn:MGRequest>
    </soapenv:Body>
    </soapenv:Envelope>
    `;

    return rowBody;
};

